export enum FileThumbnailType {
  Image = 'image',
  Video = 'video',
  Audio = 'audio',
  Document = 'document',
  Default = 'default',
  UploadProgress = 'upload-progress',
}
